import React, { useState } from "react";
import {
  FAQContainer,
  FAQTitle,
  FAQList,
  FAQItem,
  FAQAnswer,
  MoreButton,
} from "./styles";
import { faqs } from "../../../data/faqs";
import CompanyInfo from "../../common/CompanyInfo";

const FAQSection: React.FC = () => {
  const [showAll, setShowAll] = useState(false);
  const initialCount = 6;

  const visibleFaqs = showAll ? faqs : faqs.slice(0, initialCount);

  return (
    <>
      <FAQContainer>
        <FAQTitle>자주 묻는 질문</FAQTitle>
        <FAQList>
          {visibleFaqs.map((faq) => (
            <FAQItem key={faq.question}>
              <summary>
                {`Q. ${faq.question.replace("Q. ", "")}`}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  aria-hidden="true"
                >
                  <path
                    d="M14.625 6.75L9 12.375L3.375 6.75"
                    stroke="#BDBDBD"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </summary>
              <FAQAnswer>
                <p>{faq.answer.title}</p>
                {faq.answer.content.map((paragraph) => (
                  <p key={paragraph}>{paragraph}</p>
                ))}
              </FAQAnswer>
            </FAQItem>
          ))}
        </FAQList>
        {faqs.length > initialCount && !showAll && (
          <MoreButton onClick={() => setShowAll(true)}>
            더보기 ({faqs.length - initialCount}개)
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              aria-hidden="true"
            >
              <path
                d="M6.75 3.375L12.375 9L6.75 14.625"
                stroke="#667085"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </MoreButton>
        )}
      </FAQContainer>
      <CompanyInfo />
    </>
  );
};

export default FAQSection;
